'use client'

import { useEffect } from 'react'
import { setupGlobalErrorHandlers } from '@/lib/error-reporter'
import { startDebugPoller } from '@/lib/remote-debug'

/**
 * Initializes global error handlers (window.error + unhandledrejection)
 * for automatic error reporting to Corp DB.
 * Also starts the remote debug poller for Corp admin debug toggle.
 * Renders nothing — mount once in the app layout.
 */
export default function ErrorReporterInit() {
  useEffect(() => {
    setupGlobalErrorHandlers()
    startDebugPoller()
  }, [])

  return null
}
